import { render, staticRenderFns } from "./eliminacion-residuos.vue?vue&type=template&id=6320ebd4&scoped=true&"
import script from "./eliminacion-residuos.vue?vue&type=script&lang=js&"
export * from "./eliminacion-residuos.vue?vue&type=script&lang=js&"
import style0 from "./eliminacion-residuos.vue?vue&type=style&index=0&id=6320ebd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6320ebd4",
  null
  
)

export default component.exports